import { Carousel } from './components/carousel'

import initializeMenu from './specific/menu'
import initializeScroll from './specific/scroll'
import initializeExpanders from './specific/expander'

window.addEventListener('DOMContentLoaded', (event) => {
    Carousel.initializeAll()

    initializeMenu()
    //initializeScroll()
    initializeExpanders()

    ShowPlayAudio()
})


function ShowPlayAudio() {
    const video = document.querySelector('video.home-main-video')
    const button = document.getElementById('playmutebutton')

    if (!video || !button) return

    button.addEventListener('click', () => {
        button.removeAttribute('class')
        video.muted = !video.muted
        button.classList.add(video.muted ? 'muted' : 'unmuted')
    })
}